/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Input_DescriptionInputs */



/**
* | output |
* | --- |
* | "Optionally tell the agent what to work on, or point it at a file." |
*
* @param {Agent_Run_Input_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_input_description = /** @type {((inputs?: Agent_Run_Input_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Input_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Optional: Sagen Sie dem Agenten, woran er arbeiten soll, oder geben Sie ihm eine Datei.")
	return /** @type {LocalizedString} */ ("Optionally tell the agent what to work on, or point it at a file.")
});